/** Router state for a record opened from this booking: its back link and sidebar return here. */
export const bookingBackState = (payment, location) => ({
  back: {
    to: `${location.pathname}${location.search}`,
    label: payment.orderId ? `Booking #${payment.orderId}` : 'Booking',
    screen: 'bookings',
  },
});
